














	// @ts-ignore
    import _ from './MPopupPreviewQr.ts'; export default _;
